export const EMPLOYER_VENUE_SEARCH_FETCH_BEGIN = 'syftacp/EMPLOYER_VENUE_SEARCH_FETCH_BEGIN' as const
export const EMPLOYER_VENUE_SEARCH_FETCH_SUCCEEDED = 'syftacp/EMPLOYER_VENUE_SEARCH_FETCH_SUCCEEDED' as const
export const EMPLOYER_VENUE_SEARCH_FETCH_FAILED = 'syftacp/EMPLOYER_VENUE_SEARCH_FETCH_FAILED' as const

export const EMPLOYER_VENUE_NAME_FETCH_BEGIN = 'syftacp/EMPLOYER_VENUE_NAME_FETCH_BEGIN' as const
export const EMPLOYER_VENUE_NAME_FETCH_SUCCEEDED = 'syftacp/EMPLOYER_VENUE_NAME_FETCH_SUCCEEDED' as const
export const EMPLOYER_VENUE_NAME_FETCH_FAILED = 'syftacp/EMPLOYER_VENUE_NAME_FETCH_FAILED' as const
